import React from "react";
import styled from "styled-components";

const SlideShowPaddedContainer = styled.aside`
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        padding: 
          ${props.theme.spacePx(breakpoint, 7)}
          ${props.theme.marginPx(breakpoint)}
          ${props.theme.spacePx(breakpoint, 9)}
          ${props.theme.marginPx(breakpoint)}
        ;
        `;
    })}
`;

const SlideshowContainer = styled.aside`
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        height: 100vh;
        min-height: 200px;
        max-height: min(
          calc(0.6666 * (100vw - var(--sbw, 0px) - ${(
            props.theme.margin(breakpoint) * 2
          ).toFixed(4)}px)), 
          calc(${props.theme.spacePx(breakpoint, 1)} + ${props.theme.spacePx(
        breakpoint,
        2
      )}), 
          calc(100vh - ${props.theme.spacePx(
            breakpoint,
            5
          )} - ${props.theme.spacePx(breakpoint, 3)})
        );
        `;
    })}
`;

export const HeroSingleImage = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <SlideShowPaddedContainer>
      <SlideshowContainer>{children}</SlideshowContainer>
    </SlideShowPaddedContainer>
  );
};

export default HeroSingleImage;
